/*
 * Tabnavigatie op de productpagina (sections/pdp-nav.liquid), component D uit docs/page-spec.md.
 * De actieve tab volgt de sectie die in het midden van het scherm staat (IntersectionObserver).
 * Een klik scrolt zacht naar de sectie, met een marge ter hoogte van de koptekst plus de tabbalk.
 *
 * Let op: Horizon laat vanaf 990px niet het venster scrollen maar .page-wrapper. Daarom scrollt
 * deze component met scrollIntoView en scroll-margin-top, dat werkt in elke scrollcontainer;
 * window.scrollTo zou op desktop niets zichtbaars doen.
 * Tabs waarvan het anker niet op de pagina staat (bijvoorbeeld een sectie die uit staat),
 * worden verborgen.
 */
class RmPdpNav extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.rm-nav__track');
    this.links = Array.from(this.querySelectorAll('.rm-nav__link'));

    this.links.forEach((link) => {
      const target = document.getElementById(link.dataset.anchor);
      link.hidden = !target;
      link.addEventListener('click', (event) => {
        const destination = document.getElementById(link.dataset.anchor);
        if (!destination) return;
        event.preventDefault();
        destination.style.scrollMarginTop = `${this.offset()}px`;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        destination.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', `#${link.dataset.anchor}`);
        }
        this.setActive(link.dataset.anchor);
      });
    });

    this.targets = this.links
      .filter((link) => !link.hidden)
      .map((link) => document.getElementById(link.dataset.anchor))
      .filter(Boolean);

    if (this.targets.length > 0) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(entry.target.id);
          });
        },
        { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );
      this.targets.forEach((target) => this.observer.observe(target));
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  offset() {
    const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    return header + this.getBoundingClientRect().height + 16;
  }

  setActive(id) {
    this.links.forEach((link) => {
      const active = link.dataset.anchor === id;
      link.classList.toggle('is-active', active);
      if (active) {
        link.setAttribute('aria-current', 'location');
        if (this.track) {
          const left = link.offsetLeft - this.track.clientWidth / 2 + link.offsetWidth / 2;
          this.track.scrollTo({ left, behavior: 'smooth' });
        }
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('rm-pdp-nav')) {
  customElements.define('rm-pdp-nav', RmPdpNav);
}
